import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '@intranet/shared/shared.module';
import { DialogModule } from '@intranet/components/dialog/dialog.module';
import { OverlayModule } from '@intranet/components/overlay/overlay.module';
import { TooltipModule } from '@intranet/components/tooltip/tooltip.module';
import { TabsModule } from '@intranet/components/tabs/tabs.module';

import { AdminComponent } from './admin.component';
import { AdminImportComponent } from './admin-import/admin-import.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { AdminUserEditComponent } from './admin-users/manage/admin-user-edit.component';
import { AdminRolesComponent } from './admin-roles/admin-roles.component';
import { AdminDebugComponent } from './admin-debug/admin-debug.component';
import { AdminCurrencyComponent } from './admin-currency/admin-currency.component';
import { RouterModule } from '@angular/router';
import { adminRoutes } from './admin.routes';
import { AdminUserTableComponent } from './admin-users/user-table/user-table.component';
import { AdminGroupsComponent } from './admin-groups/admin-groups.component';
import { AdminGroupManageComponent } from './admin-groups/manage/admin-group-manage.component';
import { AdminGroupTableComponent } from './admin-groups/user-table/group-table.component';
import { AdminBandsComponent } from './admin-bands/admin-bands.component';
import { AvatarModule } from '@intranet/components/avatar';
import { AdminJobTypesComponent } from './admin-jobtypes/admin-jobtypes.component';
import { AdminJobTypeTableComponent } from './admin-jobtypes/jobtype-table/jobtype-table.component';
import { AdminJobTypeManageComponent } from './admin-jobtypes/manage/admin-jobtype-manage.component';
import { AdminTestMessagesComponent } from './admin-test-messages/admin-test-messages.component';

@NgModule({
    declarations: [
        AdminComponent,
        AdminImportComponent,
        AdminUsersComponent,
        AdminUserEditComponent,
        AdminRolesComponent,
        AdminDebugComponent,
        AdminCurrencyComponent,
        AdminUserTableComponent,
        AdminGroupsComponent,
        AdminGroupManageComponent,
        AdminGroupTableComponent,
        AdminBandsComponent,
        AdminJobTypesComponent,
        AdminJobTypeTableComponent,
        AdminJobTypeManageComponent,
        AdminTestMessagesComponent
    ],
    imports: [
        RouterModule.forChild(adminRoutes),
        CommonModule,
        FormsModule,
        DialogModule,
        OverlayModule,
        TooltipModule,
        TabsModule,
        SharedModule,
        AvatarModule,
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdminModule {}
